<template>
  <div class="content-wrap">
    <router-link
        class="card-link password"
        :to="{name: 'pages.changepassword'}"
    >
      Wachtwoord wijzigen
    </router-link>

    <router-link
        class="card-link feedback"
        :to="{name: 'pages.feedback'}"
    >
      Feedback geven
    </router-link>

    <a
        class="card-link faq"
        href="https://www.broodjedunner.nl/pages/veelgestelde-vragen"
        target="_blank"
    >
      Veelgestelde vragen
    </a>

    <router-link
        class="card-link logout"
        :to="{name: 'pages.logout'}"
    >
      Uitloggen
    </router-link>

    <p class="light" style="margin-top: 15px;
text-align: center; font-size: 14px;">
      Developer: <a class="light" href="https://websheriff.nl" target="_blank">Websheriff</a> - Lars van Duijkeren
    </p>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import ChangePasswordForm from "@/components/blocks/ChangePasswordForm.vue";

export default {
  name: "Settings",
  components: {
    ChangePasswordForm,
  },
  methods: {
    ...mapActions("user", [
      "logout",
    ]),
    ...mapActions("user", [
      "logout",
    ]),
  },
};
</script>
